module.exports = __webpack_public_path__ + "static/media/DT_Favicon.116d0b3e.png";